import { render, staticRenderFns } from "./AutoResizeSticky.vue?vue&type=template&id=776a2183"
import script from "./AutoResizeSticky.vue?vue&type=script&lang=ts"
export * from "./AutoResizeSticky.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports